export default __webpack_public_path__ + "static/media/5.e2d30f24.jpg";